export const userMessages = {
  'fav.empty': 'No favorites yet',
  'fav.goList': 'Browse products',
  'fav.line': '{n} saved items',
  'fav.loadFail': 'Failed to load favorites',
  'fav.title': 'Favorites',
  'forgotPassword.backLogin': 'Back to sign in',
  'forgotPassword.error.generic': 'Reset failed, try again.',
  'forgotPassword.label.account': 'Account',
  'forgotPassword.label.confirmPassword': 'Confirm new password',
  'forgotPassword.label.newPassword': 'New password',
  'forgotPassword.ph.account': 'Username',
  'forgotPassword.ph.confirmPassword': 'Repeat new password',
  'forgotPassword.ph.newPassword': 'At least 6 characters',
  'forgotPassword.submit': 'Confirm reset',
  'forgotPassword.subtitle': 'Verify your account and set a new password',
  'forgotPassword.success': 'Password reset successful. Redirecting to sign in...',
  'forgotPassword.title': 'Reset password',
  'login.error.generic': 'Sign-in failed, try again.',
  'login.footer.admin': 'Admins enter the operations console after sign-in.',
  'login.footer.customer': 'Guests can browse only; sign in for favorites, cart and reviews.',
  'login.hint.admin': 'Demo: admin / 123456',
  'login.hint.customer': 'Demo: user01 / 123456',
  'login.label.account': 'Account',
  'login.label.password': 'Password',
  'login.link.forgotPassword': 'Forgot password?',
  'login.link.register': 'No account? Sign up',
  'login.ph.account': 'Username',
  'login.ph.password': 'Password',
  'login.submit.admin': 'Enter admin',
  'login.submit.mall': 'Enter store',
  'login.subtitle': 'Choose how you sign in',
  'login.tab.admin': 'Admin',
  'login.tab.customer': 'Customer',
  'login.title': 'Welcome back',
  'register.error.generic': 'Registration failed, try again.',
  'register.error.passwordLength': 'Password must be at least 6 characters',
  'register.error.passwordMismatch': 'Passwords do not match',
  'register.hasAccount': 'Already have an account? Sign in',
  'register.label.account': 'Account',
  'register.label.confirmPassword': 'Confirm password',
  'register.label.password': 'Password',
  'register.ph.account': 'Username',
  'register.ph.confirmPassword': 'Repeat password',
  'register.ph.password': 'At least 6 characters',
  'register.submit': 'Sign up',
  'register.subtitle': 'Enter your account details',
  'register.subtitle2': 'Set up your profile',
  'register.title': 'Create account',
  'register.btn.next': 'Next',
  'register.btn.back': 'Back',
  'register.btn.randomAvatar': 'Randomize',
  'register.label.displayName': 'Display name',
  'register.label.email': 'Email (optional)',
  'register.label.avatar': 'Choose an avatar',
  'register.ph.displayName': 'How others will see you',
  'register.ph.email': 'Email address',
  'user.linkAddress': 'Addresses',
  'user.linkCart': 'Cart',
  'user.linkFav': 'Favorites',
  'user.linkOrders': 'My orders',
  'user.linkShop': 'Keep shopping',
  'user.noCity': 'City not set',
  'user.since': 'Member since',
  'user.statFav': 'Saved items',
  'user.statReviews': 'High ratings (4–5★)',
  'user.title': 'Account',
  'user.edit.btn': 'Edit Profile',
  'user.edit.save': 'Save',
  'user.edit.cancel': 'Cancel',
  'user.edit.label.displayName': 'Display Name',
  'user.edit.label.avatar': 'Avatar',
  'user.edit.label.email': 'Email',
  'user.edit.label.city': 'City',
  'user.edit.randomAvatar': 'Generate new avatar',
  'user.edit.success': 'Profile updated',
  'user.edit.error': 'Update failed',
  'user.edit.ph.city': 'City',
  'user.edit.ph.displayName': 'Display name',
  'user.edit.ph.email': 'Email address',
};
